import { h, Component } from "preact";
import { css } from "emotion";
import config from "../../../config";

const wrapper = css({
  maxWidth: 800,
  width: "100%",
  backgroundColor: "#FFF",
  margin: "0 auto",
  borderRadius: 4,
  padding: "32px 12px",
  textAlign: "center",
  boxShadow: "0 1px 10px 2px rgba(32, 7, 64, 0.13)",
  marginBottom: 14,
  display: "flex",
  "@media(max-width: 800px)": {
    padding: "24px 12px"
  }
});

class Redirect extends Component {
  componentDidMount() {
    const { redirect, wait = 0 } = this.props;
    const isBrowser = typeof window !== "undefined";
    if (isBrowser) {
      const REDIRECT_TIME = config("REDIRECT_TIME");
      setTimeout(() => {
        window.top.location = redirect.url;
      }, REDIRECT_TIME);
    }
  }
  render() {
    const { redirect, wait = 0 } = this.props;
    if (!redirect) {
      return null;
    }
    return (
      <div className={wrapper}>
        <div
          class="loading loading-lg"
          style={{ display: "inline-block", width: 100 }}
        />
        <h2 style={{ margin: "16px 0" }}>{redirect.message}</h2>
      </div>
    );
  }
}

export default Redirect;



// WEBPACK FOOTER //
// ./routes/complete/components/Redirect.js